import { createSlice } from "@reduxjs/toolkit";
import {
  addProcessorRamVoltage,
  fetchProcessorRamVoltage,
  fetchProcessorRamVoltageById,
  updateProcessorRamVoltage,
  updateStatusInProcessorRamVoltage,
} from "./thunk";

interface CategoryState {
  processor_ram_voltage_list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedCategories: any;
}

const initialState: CategoryState = {
  processor_ram_voltage_list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedCategories: null,
};

const categorySlice = createSlice({
  name: "ram_voltage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProcessorRamVoltage.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamVoltage.fulfilled, (state, action) => {
        state.loading = false;
        state.processor_ram_voltage_list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchProcessorRamVoltage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Processor Threads";
      })
      .addCase(fetchProcessorRamVoltageById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProcessorRamVoltageById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedCategories = action.payload;
      })
      .addCase(fetchProcessorRamVoltageById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(addProcessorRamVoltage.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_voltage_list = state.processor_ram_voltage_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(addProcessorRamVoltage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateProcessorRamVoltage.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.processor_ram_voltage_list = state.processor_ram_voltage_list.map((ram_capacity) =>
          ram_capacity.id === action.payload.id ? action.payload : ram_capacity
        );
      })
      .addCase(updateProcessorRamVoltage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update GP";
      })
      .addCase(updateStatusInProcessorRamVoltage.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.categoryList = state.categoryList.map((category) =>
        //   category.id === action.payload.id ? action.payload : category
        // );
      })
      .addCase(updateStatusInProcessorRamVoltage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default categorySlice.reducer;
